import { useQuery } from "@tanstack/react-query";
import { getSupabasePublicClient } from "../lib/supabasePublicClient";

/**
 * Public page: both slug and Finitless project come from the URL `/{project}/{slug}`.
 *
 * @param {string | undefined} slug
 * @param {string | undefined} finitlessProject
 */
export function usePublicLinkInBio(slug, finitlessProject) {
  const client = getSupabasePublicClient();
  const normalizedSlug = slug ? String(slug).trim().toLowerCase() : "";
  const normalizedProject = finitlessProject
    ? String(finitlessProject).trim()
    : "";

  return useQuery({
    queryKey: ["public-link-in-bio", normalizedSlug, normalizedProject || null],
    queryFn: async () => {
      if (!client || !normalizedSlug || !normalizedProject) {
        return null;
      }

      const { data, error } = await client.rpc(
        "get_public_link_in_bio_by_slug",
        {
          p_slug: normalizedSlug,
          p_finitless_project: normalizedProject,
        },
      );

      if (error) {
        throw error;
      }

      return data;
    },
    enabled: Boolean(client && normalizedSlug && normalizedProject),
    staleTime: 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
